export default {
  formatStoreName(name, nameEn) {
    if (!name) {
      return nameEn
    }
    if (!nameEn) {
      return name
    }
    return name + '(' + nameEn + ')';
  },
  formatAddress(zipcode, ...address) { // detail, city, state
    address = address.filter(item => {
      return item
    })
    let detailAddress = address.join(',')
    return zipcode ? `${detailAddress} ${zipcode}` : detailAddress;
  },
  /**
   * 
   * @param {*} val 数字字符串如3232.12
   * @param {*} flotLen 小数点后长度  默认为2
   */
  formatFloat(val = '', flotLen = 2) {
    val += '';
    var inte = val.split('.')[0] || '0';
    var flo = val.split('.')[1] || '';
    flo += '00';
    flo = flo.substr(0, flotLen);
    flo = flo ? ('.' + flo) : '';
    return inte + flo;
  },
  /**
   * formatName
   * @param firstName
   * @param lastName
   */
  formatName(firstName = '', lastName = '') {
    if (!firstName || !lastName) return firstName || lastName || '';
    var isEn = /[a-zA-Z]/gi;
    if (isEn.test(firstName) || isEn.test(lastName)) {
      return firstName + ' ' + lastName;
    }
    return lastName + '' + firstName;
  },
  /**
   * 数字千分位格式化
   * @param {*} 12345 数字
   * @param {*} 3 分割位数
   */
  formatNumber(s, n = 3) {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
    t = "";
    for (i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatUtils.js